// ⚠️  GENERATED — do not edit. Run `npm run inferrex:generate` to regenerate.
/**
 * @inferrex/sdk — Schema resource client
 * Generated from route definitions in services/api/route-definitions.ts
 */

import type { HttpClient } from '../http.js';

export class SchemaClient {
  constructor(private readonly http: HttpClient) {}

  /** Declared-or-inferred field source for an entity (declared from TableDefinitions, inferred from intelligence.schema_contracts). */
  async getEntitySchema(entity: string): Promise<{ kind: string; fields: Record<string, unknown> | null; entity: Record<string, unknown> | null }> {
    return this.http.get<{ kind: string; fields: Record<string, unknown> | null; entity: Record<string, unknown> | null }>(`/v1/schema/${entity}`);
  }
}
